import React, { createRef, RefObject, ReactNode } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import Progress from "../components/Progress";
import { Alert } from 'react-bootstrap'
import { eventEmitter } from "../classes/EventEmitter";
import { EVENTS } from "../AppConstants";
import Utilities from "../classes/Utilities";
import { IAppState } from "../state/interfaces";
import { connect } from "react-redux";
import { getPortalSettings } from "../config/portalSettings";

interface IProps {
    id: string,
    progress?: ReactNode | null,
    header?: ReactNode | null,
    footer?: ReactNode | null,
    className?: string,
    children: any,
    stateCode: string | null;
}

interface IState {
    apiCallError: string
}

class QuoteStep extends React.Component<IProps, IState> {
    rootRef: RefObject<HTMLDivElement>

    constructor(props: IProps) {
        super(props);

        this.rootRef = createRef();

        this.state = {
            apiCallError: ""
        };
    }

    componentDidMount() {     
        eventEmitter.subscribe(EVENTS.API_CALL_FAILURE_BAD_REQUEST, this.props.id,
            (error) => {
                this.setState({ ...this.state, apiCallError: error.errorMessage });
                this.scrollToTop();
            });

        eventEmitter.subscribe(EVENTS.API_CALL_FAILURE_COMMON, this.props.id,
            () => {
                this.setState({ ...this.state, apiCallError: "DEFAULT" });
                this.scrollToTop();
            });

        this.scrollToTop();
    }  

    componentWillUnmount() {
        eventEmitter.unsubscribe(EVENTS.API_CALL_FAILURE_BAD_REQUEST, this.props.id);
        eventEmitter.unsubscribe(EVENTS.API_CALL_FAILURE_COMMON, this.props.id);
    }

    scrollToTop() {
        if (null != this.rootRef.current) {
            this.rootRef.current.scrollIntoView({
                behavior: "smooth",
            });
        }
    }

    render() {
        return (
            <div ref={this.rootRef}>
                { !this.props.header ? <Header /> : this.props.header }
                { !this.props.progress ? <Progress /> : this.props.progress }
                

                <div className="quote-step-body">
                    <div className="quote-step-container">
                        <div className="qContainer card">
                            <div className={"card-body " + (this.props.className ? this.props.className : "")}>
                                {
                                    this.state.apiCallError
                                        ? <div>
                                            <Alert variant={"danger"}>
                                                <p><strong className="text-uppercase">Application Error!</strong></p>
                                                {"DEFAULT" === this.state.apiCallError
                                                    ?   <div>
                                                            <p className="text-uppercase">We’re experiencing a technical problem on our side, sorry about that.</p>
                                                            <p className="text-uppercase">Please contact our Customer Service Center and we’ll be happy to assist you with completing the purchase of your policy.</p>
                                                        <h5 className="text-uppercase font-weight-bold">{getPortalSettings().customerServicePhone}</h5>
                                                        <div>&nbsp;</div>
                                                        </div>
                                                    : <p className="text-uppercase" dangerouslySetInnerHTML={{ __html: this.state.apiCallError }}></p>}
                                                <p><a href={Utilities.getHomePageUrl()} className="font-weight-bold m-b-0"><i className="fas fa-chevron-left"></i> Home</a></p>
                                            </Alert>
                                            <div className="break-2" />
                                        </div>
                                        : null
                                }
                                {this.props.children}
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        bindResult: state.externalQuote?.bindResult,
        stateCode: state.stateCode
    };
};

export default connect(mapProps, null)(QuoteStep);
   